/**
 * How long the boot overlay takes to leave (#1066): `.boot.leaving` in `app.css` fades it
 * and shrinks the mark to 0.9 over the same 0.24 s.
 */
export const BOOT_EXIT_MS = 240;

/**
 * Take the boot overlay down, at once and wherever the Fold together loop is (#1066).
 *
 * The screen under it is already drawn, so the overlay fades off it rather than the screen
 * waiting for the animation; a quick start never waits for the loop. It stops taking taps
 * the moment it starts leaving. With reduced motion asked for it goes in one step, as it
 * always did. Both places that take it down call this: boot when signed out, and
 * `BootRelease` in `app.tsx` when signed in.
 */
export function releaseBootOverlay(overlay: HTMLElement | null = document.getElementById("boot")): void {
  if (!overlay || overlay.hidden || overlay.classList.contains("leaving")) return;
  if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) {
    overlay.hidden = true;
    return;
  }
  overlay.classList.add("leaving");
  window.setTimeout(() => {
    overlay.hidden = true;
    overlay.classList.remove("leaving");
  }, BOOT_EXIT_MS);
}

/**
 * Boot has stopped short: the mark holds still (the loop says "still working", and nothing
 * is until the person acts), and stops saying "Getting ready…" to a screen reader. The
 * line under it says what happened.
 */
export function stopBootMark(overlay: Element | null): void {
  if (!overlay) return;
  overlay.classList.add("failed");
  overlay.querySelector(".boot-mark")?.setAttribute("aria-hidden", "true");
}

/** Whether the overlay still holds the screen: up, and not already on its way out. */
export function bootOverlayUp(overlay: HTMLElement | null): overlay is HTMLElement {
  return !!overlay && !overlay.hidden && !overlay.classList.contains("leaving");
}
